import { Text } from '@wix/design-system'
import { useContent } from '@wix/funnel-builder-lizard'
import { ChevronLeft } from '@wix/wix-ui-icons-common'
import React, { FC, useEffect } from 'react'

import { usePageLogger } from '../../../bi/mfi'
import { ErrorNotificationOutlet } from '../../../components/ErrorNotification/ErrorNotificationOutlet'
import { useBrowserTabTitle } from '../../../hooks/useBrowserTabTitle'
import WixLogo from '../../reusable/icons/WixLogo.svg'
import Icon from './icon.svg'
import { dataHooks } from './SGLandingMobile.dataHooks'
import s from './SGLandingMobile.scss'

export type Content = {
  title: string
  text: string
  backLink: string
  browserTabTitle: string
}

export const SGLandingMobile: FC = () => {
  const { content } = useContent<Content>()
  const pageLogger = usePageLogger()
  useBrowserTabTitle(content.browserTabTitle)

  useEffect(() => {
    void pageLogger.screenView()
  }, [pageLogger])

  return (
    <div className={s.SGLandingMobile}>
      <div>
        <a href={content.backLink} className={s.SGLandingMobile__backLink} data-hook={dataHooks.backLink()}>
          <ChevronLeft />
          <div className={s.SGLandingMobile__headingDivider} />
          <WixLogo height="15px" />
        </a>
      </div>
      <ErrorNotificationOutlet />
      <div className={s.SGLandingMobile__content}>
        <Icon className={s.SGLandingMobile__icon} />
        <Text dataHook={dataHooks.title()} className={s.SGLandingMobile__title}>
          {content.title}
        </Text>
        <Text dataHook={dataHooks.text()} className={s.SGLandingMobile__text}>
          {content.text}
        </Text>
      </div>
    </div>
  )
}
